/* global BX, CatalogCardState */
(function () {
    if (!document.querySelector('#basket-panel')) return;

    function getMaxQuantity(card) {
        const attr = card.getAttribute('data-quantity');
        if (attr === null || attr === '') return Infinity;
        const qty = parseInt(attr, 10);
        return isNaN(qty) ? Infinity : qty;
    }

    function initCounters() {
        const counters = document.querySelectorAll('#product-info-block #basket-counter');
        counters.forEach((counter) => {
            const card = counter.closest('#product-info-block');
            if (!card) return;

            const digitSpan = counter.querySelector('#basket-digit');
            if (!digitSpan) return;

            let currentValue = parseInt(digitSpan.textContent, 10);
            if (isNaN(currentValue) || currentValue < 1) {
                currentValue = 1;
                digitSpan.textContent = currentValue;
            }

            const maxQuantity = getMaxQuantity(card);
            if (maxQuantity > 0 && currentValue > maxQuantity) {
                currentValue = maxQuantity;
                digitSpan.textContent = currentValue;
            }

            const minusBtn = counter.querySelector('#basket-minus');
            const plusBtn = counter.querySelector('#basket-plus');

            const minusHandler = (e) => {
                e.stopPropagation();
                let val = parseInt(digitSpan.textContent, 10);
                if (isNaN(val)) val = 1;
                if (val > 1) {
                    val--;
                    digitSpan.textContent = val;
                }
            };

            const plusHandler = (e) => {
                e.stopPropagation();
                let val = parseInt(digitSpan.textContent, 10);
                if (isNaN(val)) val = 1;
                if (maxQuantity > 0 && val < maxQuantity) {
                    val++;
                    digitSpan.textContent = val;
                }
            };

            if (minusBtn) {
                minusBtn.removeEventListener('click', minusHandler);
                minusBtn.addEventListener('click', minusHandler);
            }
            if (plusBtn) {
                plusBtn.removeEventListener('click', plusHandler);
                plusBtn.addEventListener('click', plusHandler);
            }
        });
    }

    function isDetailPage(card) {
        return card.querySelector('.catalog-detail__purchase-base');
    }

    function getButtonText(card, isDisabled) {
        if (isDisabled) return 'Нет в наличии';
        return isDetailPage(card) ? 'В корзину' : 'Купить';
    }

    function getBasketButtonElement(card) {
        return card.querySelector('#basket-panel .btn');
    }

    function transformButtonToCartLink(button, card) {
        const counter = card.querySelector('#basket-counter');
        if (counter) {
            counter.style.display = 'none';
        }
        const newLink = document.createElement('a');
        newLink.href = '/basket';
        newLink.className = button.className;
        newLink.textContent = '✓ В корзине';
        newLink.style.backgroundColor = 'var(--color-green)';
        newLink.style.display = 'inline-flex';
        newLink.style.alignItems = 'center';
        newLink.style.justifyContent = 'center';
        newLink.style.textDecoration = 'none';
        button.replaceWith(newLink);
    }

    function transformLinkToButton(link, card) {
        const counter = card.querySelector('#basket-counter');
        const maxQuantity = getMaxQuantity(card);
        const isDetail = isDetailPage(card);

        if (counter) {
            counter.style.display = maxQuantity > 0 ? '' : 'none';
        }

        const button = document.createElement('button');
        if (isDetail) {
            button.className = link.className;
        } else {
            button.className = 'btn btn--mini btn--mini--font';
        }
        button.disabled = maxQuantity === 0;
        button.textContent = getButtonText(card, maxQuantity === 0);
        button.addEventListener('click', onButtonClick);
        link.replaceWith(button);
    }

    function sendRequest(productId, iblockId, quantity) {
        const params = new URLSearchParams();
        params.append('add_item', 'Y');
        params.append('item', productId);
        params.append('quantity', quantity);
        params.append('iblockID', iblockId);
        params.append('offers', 'N');
        params.append('part_props', 'N');
        params.append('add_props', 'Y');
        params.append('prop[]', '0');
        params.append('props', '""');
        params.append('basket_props', '');
        params.append('rid', '');
        return fetch('/ajax/item.php', {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: params.toString(),
            credentials: 'same-origin',
        });
    }

    async function onButtonClick(event) {
        const button = event.currentTarget;
        if (button.tagName === 'A' || button.disabled) return;
        const card = button.closest('#product-info-block');
        if (!card) return;
        const productId = card.getAttribute('data-product-id');
        const iblockId = card.getAttribute('data-iblock-id');
        if (!productId || !iblockId) return;

        const maxQuantity = getMaxQuantity(card);
        if (maxQuantity === 0) return;

        let digitSpan = null;
        if (isDetailPage(card)) {
            digitSpan = card.querySelector('.counter__digit');
        } else {
            digitSpan = card.querySelector('#basket-digit');
        }
        let quantity = 1;
        if (digitSpan) {
            let count = digitSpan.tagName === 'INPUT' ? digitSpan.value : digitSpan.textContent;
            let qty = parseInt(count, 10);
            if (!isNaN(qty) && qty > 0) quantity = qty;
        }

        if (maxQuantity > 0) {
            quantity = Math.min(quantity, maxQuantity);
        }

        await sendRequest(productId, iblockId, quantity)
            .then((response) => {
                if (!response.ok) throw new Error();
                const currentButton = card.querySelector('#basket-panel .btn');
                if (currentButton && currentButton.tagName !== 'A') {
                    transformButtonToCartLink(currentButton, card);
                }
                if (typeof window.addBasketCounter === 'function') {
                    window.addBasketCounter(productId);
                }
            })
            .catch(() => {
                // ignore
            });
        if (window.BX?.onCustomEvent) {
            BX.onCustomEvent('onCompleteAction', [{action: 'loadBasket'}]);
        }
    }

    function applyQuantityConstraints(card) {
        const maxQuantity = getMaxQuantity(card);
        const button = getBasketButtonElement(card);
        const counter = card.querySelector('#basket-counter');
        const isInBasket = button && button.tagName === 'A';

        if (isInBasket) {
            if (counter) counter.style.display = 'none';
            return;
        }

        if (maxQuantity === 0) {
            if (button) {
                button.disabled = true;
                button.textContent = 'Нет в наличии';
            }
            if (counter) counter.style.display = 'none';
        } else {
            if (button) {
                button.disabled = false;
                button.textContent = getButtonText(card, false);
            }
            if (counter) counter.style.display = '';
        }
    }

    function syncUI() {
        const productsInBasket = Object.keys(CatalogCardState.basket);
        const cards = document.querySelectorAll('#product-info-block');

        cards.forEach((card) => {
            const productId = card.getAttribute('data-product-id');
            if (!productId) return;

            const element = getBasketButtonElement(card);
            const isInBasket = productsInBasket.includes(productId);
            const isLink = element && element.tagName === 'A';

            if (isInBasket === isLink) {
                applyQuantityConstraints(card);
                return;
            }

            if (isInBasket) {
                transformButtonToCartLink(element, card);
            } else {
                transformLinkToButton(element, card);
            }
        });
    }

    function initButtons() {
        const cards = document.querySelectorAll('#product-info-block');
        cards.forEach((card) => {
            applyQuantityConstraints(card);
            const button = getBasketButtonElement(card);
            if (button && button.tagName !== 'A') {
                button.removeEventListener('click', onButtonClick);
                button.addEventListener('click', onButtonClick);
            }
        });
        initCounters();
        syncUI();
    }

    CatalogCardState.onReady(() => {
        initButtons();
        CatalogCardState.addUpdateListener(syncUI);
    });
})();
